import { VueConstructor } from 'vue';
import * as cps from './components';
export * from './components';
import config from './config';
import LoginHelper, { UserInfo } from './components/AheduHeader/LoginHelper';

export default {
  config,
  /**
   * 自定义获取用户信息的方法
   * @param getUser
   */
  customGetUser(getUser: () => Promise<UserInfo>): void {
    LoginHelper.getUser = getUser;
  },
  install(Vue: VueConstructor): void {
    cps.default.install(Vue);
  },
};
